import React from "react";
import { Link } from "react-router-dom";
import "./Program.css";

export default function Program() {
  // Fatherhood programming image from Pexels
  const programImageUrl = "/father.jpg";
  
  return (
    <section className="cis-program" id="program" aria-labelledby="program-title">
      <div className="cis-program__container">
        <div className="cis-program__grid">
          {/* Left Column - Content */}
          <div className="cis-program__content">
            <h2 id="program-title" className="cis-program__title">
              Fatherhood Program
            </h2>
            <div className="cis-program__textGroup">
              <p className="cis-program__text">
                Our Fatherhood Program is built on one core belief: when fathers are involved, 
                children, families, and communities thrive. We create a supportive space where dads 
                can strengthen their connection with their children and become more confident, engaged, 
                and present in their parenting role.
              </p>
              <p className="cis-program__text">
                Our programming helps fathers deepen their bond with their children through positive, 
                hands-on engagement while strengthening co-parenting relationships and overall family 
                communication. Participants learn effective parenting strategies rooted in patience, 
                structure, and love, and build greater stability through job readiness training and 
                essential life skills development. We also support fathers in overcoming barriers that 
                may limit their involvement, such as navigating complex systems or accessing needed 
                resources, and provide opportunities to connect with other fathers who share similar 
                experiences and goals.
              </p>
              <p className="cis-program__text">
                Every father has the potential to make a lasting impact. Our role is to uplift, guide, 
                and equip dads so they can stay actively involved, emotionally connected, and fully 
                engaged with their children at every stage.
              </p>
            </div>
            <div className="cis-program__buttonWrap">
              <Link to="/contact" className="cis-program__button">
                Request a Consultation
              </Link>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="cis-program__imageWrap">
            <div className="cis-program__imageContainer">
              <img
                className="cis-program__image"
                src={programImageUrl}
                alt="Father spending quality time with his children"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}